import { IRequestStatus, Role, RequestStatus } from "@/models";

export const displayedStatusFilter = (status: IRequestStatus, role: Role): string => {
    let result: string;
    if (status !== null && status !== undefined && role !== null && role !== undefined) {
        switch (status.name) {
            case RequestStatus.submitted.toString():
                result = role === Role.Admin ? "Pending" : RequestStatus.submitted.toString();
                break;
            case RequestStatus.toModify.toString():
                result = "To complete";
                break;
            case RequestStatus.toReview.toString():
                if (role === Role.User) {
                    result = RequestStatus.submitted.toString();
                } else {
                    result = "Panel review";
                }
                break;
            case RequestStatus.mixed.toString():
                result = "Panel warning";
                break;
            default:
                result = status.name.toString();
        }
    } else if (!!status) {
        result = status.name;
    } else {
        result = "";
    }

    return result.toLocaleLowerCase();
};
